import React from 'react';
import PropTypes from 'prop-types';

import RacingThemeRoot from '../RacingThemeRoot/RacingThemeRoot';
import RacingThemeSearchFilterPanel from '../RacingThemeSearchFilterPanel/RacingThemeSearchFilterPanel';
import RacingThemeSearchResultsPanel from '../RacingThemeSearchResultsPanel/RacingThemeSearchResultsPanel';
import {
  SEARCH_ACTIVE_FILTERS,
  SEARCH_FILTER_GROUPS,
  SEARCH_LISTINGS,
  SEARCH_RESULTS_META,
} from '../RacingThemeSearch/searchResultsContent';
import styles from './RacingThemeSearchBody.module.css';

const listingShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

const filterGroupShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

/**
 * Search results body — composes filter sidebar and results panel.
 */
const RacingThemeSearchBody = props => {
  const {
    filterGroups = SEARCH_FILTER_GROUPS,
    activeFilters = SEARCH_ACTIVE_FILTERS,
    listings = SEARCH_LISTINGS,
    count = SEARCH_RESULTS_META.count,
    query = SEARCH_RESULTS_META.query,
    sortOptions = SEARCH_RESULTS_META.sortOptions,
    activeSort = SEARCH_RESULTS_META.activeSort,
    onClearAll,
    onOptionChange,
    onPriceCommit,
    onSortChange,
    onRemoveFilter,
    pagination,
    pageName,
    pagePathParams,
    pageSearchParams,
    filterPanelChildren,
    resultsChildren,
    onToggleFavorite = null,
  } = props;

  return (
    <RacingThemeRoot className={styles.searchBodyRoot}>
      <div className={styles.searchBody}>
        <RacingThemeSearchFilterPanel
          groups={filterGroups}
          onClearAll={onClearAll}
          onOptionChange={onOptionChange}
          onPriceCommit={onPriceCommit}
        >
          {filterPanelChildren}
        </RacingThemeSearchFilterPanel>
        <RacingThemeSearchResultsPanel
          filters={activeFilters}
          listings={listings}
          count={count}
          query={query}
          sortOptions={sortOptions}
          activeSort={activeSort}
          onSortChange={onSortChange}
          onRemoveFilter={onRemoveFilter}
          pagination={pagination}
          pageName={pageName}
          pagePathParams={pagePathParams}
          pageSearchParams={pageSearchParams}
          onToggleFavorite={onToggleFavorite}
        >
          {resultsChildren}
        </RacingThemeSearchResultsPanel>
      </div>
    </RacingThemeRoot>
  );
};

RacingThemeSearchBody.propTypes = {
  filterGroups: PropTypes.arrayOf(filterGroupShape),
  activeFilters: PropTypes.array,
  listings: PropTypes.arrayOf(listingShape),
  count: PropTypes.number,
  query: PropTypes.string,
  sortOptions: PropTypes.array,
  activeSort: PropTypes.string,
  onClearAll: PropTypes.func,
  onOptionChange: PropTypes.func,
  onPriceCommit: PropTypes.func,
  onSortChange: PropTypes.func,
  onRemoveFilter: PropTypes.func,
  pagination: PropTypes.object,
  pageName: PropTypes.string,
  pagePathParams: PropTypes.object,
  pageSearchParams: PropTypes.object,
  filterPanelChildren: PropTypes.node,
  resultsChildren: PropTypes.node,
  onToggleFavorite: PropTypes.func,
};

export default RacingThemeSearchBody;
